import React from "react";
import AdminNavBar from "../AdminSideNavBar";
import SideNavBar from "../SideNavBar";
import { withRouter } from "react-router-dom";
import NetworkDetector from "../HigherOrderComponents/NetworkDetector";
import authService from "../../services/authService";
import GrammarCheck from "../GrammarCheck";

const GrammarCheckPage = props => {
  const user = authService.getCurrentUser();
  let userData = {};
  if (props.location.state) {
    userData = props.location.state.userData;
    console.log("myDocumentPage", userData);
  }
  if (!user.isAdmin) {
    return (
      <SideNavBar>
        <GrammarCheck />
      </SideNavBar>
    );
  } else {
    return (
      <AdminNavBar>
        <GrammarCheck data={userData} />
      </AdminNavBar>
    );
  }
};

export default NetworkDetector(withRouter(GrammarCheckPage));
